import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isImage)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.file.url,
          style: {"display":"block","max-width":"100%"}
        }, null, 8, _hoisted_1))
      : (_ctx.isVideo)
        ? (_openBlock(), _createElementBlock("video", {
            key: 1,
            src: _ctx.file.url,
            controls: "",
            width: "100%"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
  ]))
}